<template>
  <transition name="loader-fade">
    <div v-if="show" class="app-loader">
      <div class="app-loader-content">
        <div class="app-loader-spinner"></div>

        <div v-if="message" class="app-loader-message">
          {{ message }}
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "AppLoader",

  computed: {
    show() {
      return this.$store.getters.showOverlay;
    },

    message() {
      return this.$store.getters.overlayMessage;
    },
  },
};
</script>

<style scoped>
.app-loader {
  position: fixed;
  inset: 0;
  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(2px);
}

.app-loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;

  padding: 24px 32px;
  border-radius: 12px;

  background: #fff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.app-loader-spinner {
  width: 42px;
  height: 42px;

  border: 4px solid #e5e7eb;
  border-top-color: #3699ff;
  border-radius: 50%;

  animation: loader-spin 0.8s linear infinite;
}

.app-loader-message {
  font-size: 14px;
  font-weight: 500;
  color: #444;
}

@keyframes loader-spin {
  to {
    transform: rotate(360deg);
  }
}

.loader-fade-enter-active,
.loader-fade-leave-active {
  transition: opacity 0.2s ease;
}

.loader-fade-enter,
.loader-fade-leave-to {
  opacity: 0;
}
</style>
